import { Button, cn } from "@tellescope/design-system";
import { ClipboardCheck } from "lucide-react";
import { BlockProps } from "../../../types";
import { useEligibilityBlock } from "../../../hooks";
import { BlockHeader } from "../BlockHeader";
import { BlockContent } from "../BlockContent";
import { EligibilityRecordsList } from "./EligibilityRecordsList";
import { EligibilitySubmissionForm } from "./EligibilitySubmissionForm";
import { useTranslation } from "react-i18next";
import { BlockEmptyState } from "../BlockEmptyState";

export const EligibilityBlock = ({
  onMaximize,
  alwaysShowButtons = false,
  className,
  contentClassName,
  ...rest
}: BlockProps) => {
  const { t } = useTranslation("eligibility");
  const {
    parsedInfo,
    enduser,
    hasInsurance,
    showSubmissionForm,
    openSubmissionForm,
    closeSubmissionForm,
    isEditingTitle,
    setIsEditingTitle,
    newTitle,
    setNewTitle,
    editMode,
    setEditMode,
    updateInfo,
    duplicateBlock,
    deleteBlock,
    toggleExpanded,
    expanded,
    blockLayout,
    canEditTitle,
    canCreateBlock,
    canDeleteBlock,
  } = useEligibilityBlock({ ...rest, onMaximize, alwaysShowButtons, className });

  return (
    <div className={cn("group", className)}>
      <BlockHeader
        editMode={editMode}
        setEditMode={setEditMode}
        isEditingTitle={isEditingTitle}
        setIsEditingTitle={setIsEditingTitle}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        canEditTitle={canEditTitle}
        parsedInfo={parsedInfo}
        updateInfo={updateInfo}
        duplicateBlock={duplicateBlock}
        deleteBlock={deleteBlock}
        canCreateBlock={canCreateBlock}
        canDeleteBlock={canDeleteBlock}
        onMaximize={onMaximize}
        alwaysShowButtons={alwaysShowButtons}
        actions={
          editMode &&
          hasInsurance &&
          !showSubmissionForm && (
            <Button variant="outline" size="sm" onClick={openSubmissionForm}>
              <ClipboardCheck />
              {t("Run Eligibility Check")}
            </Button>
          )
        }
      />

      <BlockContent
        editMode={editMode}
        setEditMode={setEditMode}
        expanded={expanded}
        layout={blockLayout}
        onToggleExpanded={() => toggleExpanded()}
        className={cn("flex flex-col", contentClassName)}
      >
        {!enduser ? (
          <div className="flex flex-1 items-center justify-center">
            <BlockEmptyState>{t("Loading eligibility...")}</BlockEmptyState>
          </div>
        ) : showSubmissionForm ? (
          <EligibilitySubmissionForm contact={enduser} onSubmit={closeSubmissionForm} onCancel={closeSubmissionForm} />
        ) : (
          <EligibilityRecordsList contact={enduser} />
        )}
      </BlockContent>
    </div>
  );
};
